import { Component, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ChartDataSets, ChartLegendItem, ChartOptions, ChartType, Chart } from 'chart.js';
import * as $ from 'jquery';
import { NumberFormatPipe } from '../../modules/pipe/number-format.pipe';
import { PublicReportService } from '../../modules/services/public-report.service';
import { ConfigurableFocusTrap } from '@angular/cdk/a11y';
import * as _ from 'lodash';
import * as _moment from 'moment';
const moment = _moment;

@Component({
  selector: 'app-vaccination-dashboard',
  templateUrl: './vaccination-dashboard.component.html',
  styleUrls: ['./vaccination-dashboard.component.scss']
})
export class VaccinationDashboardComponent implements OnInit {
  todaysdate;
  headerTextLbl = 'State';
  breadCrumbArr = [];
  type;
  state_id;
  state_name;
  district_id;
  district_name;
  vaccinationDashboardReport = [];
  vaccinationData;
  vaccinationTrendChartData;
  vaccinationTrendChart;
  vaccinationCoverageByStateChartData;
  vaccinationCoverageByStateChart;
  vaccinationByAgeChartData;
  vaccinationByAgeChart;
  vaccinationDoseChartData;
  vaccinationDoseChart;
  vaccinationBrandChartData;
  vaccinationBrandChart;
  vaccinationAEFIChartData;
  vaccinationAEFIChart;
  vaccinatedAefiPer = 0;
  constructor(
    private publicReportService: PublicReportService,
    public deviceService: DeviceDetectorService,
    public datepipe: DatePipe,
    public numberFormatPipe: NumberFormatPipe
  ) { }

  ngOnInit(): void {
    this.todaysdate = new Date();
    this.todaysdate = this.datepipe.transform(this.todaysdate, 'yyyy-MM-dd');
    this.publicReportService.filterParams.date = this.datepipe.transform(this.todaysdate, 'yyyy-MM-dd');
    this.publicReportService.getDistrictname().subscribe(val => {
      if (val && val != undefined) {
        this.district_name = val;
      }
    })
    this.publicReportService.getDistrictID().subscribe(val => {
      if (val && val != undefined) {
        this.district_id = val;
      }
    })
    this.publicReportService.getSessionStatus().subscribe(val => {
      if (val && val != undefined) {
        this.state_id = val;
      }
    })
    this.publicReportService.getStatename().subscribe(val => {
      if (val && val != undefined) {
        this.state_name = val;
      }
    })
    //console.log(this.publicReportService);
  }

  nextLevel(type) {
    console.log(type);
    console.log(this.state_id+'-'+this.state_name+'- '+this.district_id+' -'+this.district_name);
    this.publicReportService.tabname.next("Vaccination");
    this.headerTextLbl = type;
    if (this.headerTextLbl == 'Center') {
      return;
    } else if (this.headerTextLbl === 'India') {
      this.breadCrumbArr = [];
      this.district_id="";
      this.district_name = "";
      this.state_id = "";
      this.headerTextLbl = 'State';
      this.publicReportService.ischeckSessionStarted.next(this.state_id);
      this.publicReportService.district_id.next(this.district_id);
      this.publicReportService.districtname.next(this.district_name);
      this.publicReportService.type.next("India");
      this.publicReportService.isnational.next(true);
      this.getVaccinationDashboard(this.todaysdate,this.state_id,this.district_id);
    } else if (this.headerTextLbl === 'State') {
      this.breadCrumbArr = [];
      this.district_id="";
      this.district_name = "";
      if(this.breadCrumbArr.length == 0){
        this.breadCrumbArr.push({
          type: 'India',
          id: '',
          name: 'India'
        });
        this.breadCrumbArr.push({
          type: 'State',
          id: this.state_id,
          state_id: this.state_id,
          state_name: this.state_name,
          name: this.state_name
        });
      }
      this.publicReportService.ischeckSessionStarted.next(this.state_id);
      this.publicReportService.statename.next(this.state_name);
      this.publicReportService.district_id.next(this.district_id);
      this.publicReportService.districtname.next(this.district_name);
      this.publicReportService.isnational.next(false);
      this.publicReportService.type.next("State");
      this.getVaccinationDashboard(this.todaysdate,this.state_id,this.district_id);
    } else if (this.headerTextLbl === 'District') {
        this.breadCrumbArr = [];
        this.breadCrumbArr.push({
          type: 'India',
          id: '',
          name: 'India'
        });
        this.breadCrumbArr.push({
          type: 'State',
          id: this.state_id,
          state_name: this.state_name,
          state_id: this.state_id,
          name: this.state_name
        });

      this.breadCrumbArr.push({
        type: 'District',
        id: this.district_id,
        district_id: this.district_id,
        district_name: this.district_name,
        name: this.district_name
      });

      this.publicReportService.ischeckSessionStarted.next(this.state_id);
      this.publicReportService.statename.next(this.state_name);
      this.publicReportService.district_id.next(this.district_id);
      this.publicReportService.districtname.next(this.district_name);
      this.publicReportService.isnational.next(false);
      this.publicReportService.type.next("District");
      this.getVaccinationDashboard(this.todaysdate,this.state_id,this.district_id);
    }

  }

  getVaccinationDashboard(datefilter,state_id,district_id) {

    this.publicReportService.getVaccinationDashboardData(state_id, district_id, this.todaysdate).subscribe(res => {
      this.vaccinationDashboardReport = res;
      this.vaccinatedAefiPer = res.aefiPercentage;
      this.vaccinationData = res.topBlock;
      this.vaccinationTrendChartData = res.vaccinationDoneByTime;
      this.vaccinationCoverageByStateChartData = res.getBeneficiariesGroupBy;
      this.vaccinationByAgeChartData = res.vaccinationByAge;
      this.vaccinationDoseChartData = res.last7DaysVaccination;
      this.vaccinationBrandChartData = res.last7DaysVaccination;
      this.vaccinationAEFIChartData = res.last7DaysVaccination;
      this.loadVaccinationTrendChart();
      this.loadVaccinationCoverageByState();
      this.loadVaccinationByAgeChart();
      this.loadVaccinationDoseLastSevenDaysChart();
      this.loadVaccinationAEFIChart();
      this.loadVaccinationBrandLastSevenDaysChart();
    },
      err => {
        console.log("error", err)
        this.vaccinationDashboardReport = [];
      });
  }

  //vaccination trends chart
  loadVaccinationTrendChart() {
    if (this.vaccinationTrendChart) {
      this.vaccinationTrendChart.destroy();
    }
    const labels = _.map(this.vaccinationTrendChartData, 'label');
    const total = _.map(this.vaccinationTrendChartData, 'count');
    const dose_1 = _.map(this.vaccinationTrendChartData, 'dose_one');
    const dose_2 = _.map(this.vaccinationTrendChartData, 'dose_two');
    const format = this.numberFormatPipe;
    var configuration = {
      type: 'horizontalBar',
      data: {
        labels: labels,
        datasets: [
          {
            label: "Total",
            backgroundColor: "rgb(242, 9, 251, 0.5)",
            borderColor: 'rgb(242, 9, 251)',
            data: total,
            borderWidth: 2,
            pointBackgroundColor: "rgb(167, 0 , 73)",
            pointBorderWidth: 1,
            pointRadius: 3,
            fill: false
          },
          {
            label: "Dose 1",
            backgroundColor: "rgb(20, 232, 251, 0.5)",
            borderColor: 'rgb(20, 232, 251)',
            borderWidth: 2,
            pointBackgroundColor: 'rgb(1, 161, 179)',
            pointBorderWidth: 1,
            pointRadius: 3,
            fill: false,
            data: dose_1

          },
          {
            label: "Dose 2",
            backgroundColor: "rgb(251, 167, 20, 0.5)",
            borderColor: 'rgb(251, 167, 20)',
            borderWidth: 2,
            pointBackgroundColor: 'rgb(185, 118, 0)',
            pointBorderWidth: 1,
            pointRadius: 3,
            fill: false,
            data: dose_2
          }
        ]
      },
      options: {
        legend: {
          display: true,
          position: 'bottom',
          labels: {
            usePointStyle: false,
            boxWidth: 20,
            padding: 15,
            fontSize: 9,
          }
        },
        tooltips: {
          mode: 'index',
          intersect: false,
          callbacks: {
            label: function (tooltipItem, data) {
              var label = data.datasets[tooltipItem.datasetIndex].label || '';

              if (label) {
                label += ': ';
              }

              const dataNum = Math.round(tooltipItem.xLabel * 100) / 100;
              label += format.transform(dataNum);
              return label;
            }
          }
        },
        responsive: true,
        scales: {
          xAxes: [{
            // stacked: true,
            barPercentage: 0.3,
            gridLines: {
              color: 'rgb(247, 250, 252)',
              borderDash: [5, 2],
              zeroLineColor: 'rgb(247, 250, 252)',
            },
            ticks: {
              fontSize: 9,
              beginAtZero: true,
              callback: function (label, index, labels) {
                return label / 1000 + 'k';
              }
            }
          }],
          yAxes: [{
            beginAtZero: false,
            ticks: {
              autoSkip: false,
              fontSize: 11,
            },
            // stacked: true,
            gridLines: {
              display: false,
              drawBorder: false,
            },
          }]
        }
      }
    };
    const ctx = $('#vaccination-trends');
    this.vaccinationTrendChart = new Chart(ctx, configuration);
    this.vaccinationTrendChart.update();
  }

  //vaccination coverage by state
  loadVaccinationCoverageByState() {
    const format = this.numberFormatPipe;
    if (this.vaccinationCoverageByStateChart) {
      this.vaccinationCoverageByStateChart.destroy();
    }
    //vaccinationCoverageByStateChartData
    const labels = _.map(this.vaccinationCoverageByStateChartData, 'title')
    //const total = _.map(this.vaccinationCoverageByStateChartData,'total')
    const partially_vaccinated = _.map(this.vaccinationCoverageByStateChartData, 'partial_vaccinated')
    const totally_vaccinated = _.map(this.vaccinationCoverageByStateChartData, 'totally_vaccinated')
    var configuration = {
      type: 'bar',
      data: {
        labels: labels,
        datasets: [
          {
            type: 'bar',
            label: 'Partially Vaccinated',
            backgroundColor: "rgb(242, 9, 251, 0.5)",
            borderColor: "rgb(242, 9, 251, 0.5)",
            data: partially_vaccinated,
          },
          {
            type: 'bar',
            label: 'Fully Vaccinated',
            backgroundColor: "rgb(20, 232, 251, 0.5)",
            borderColor: "rgb(20, 232, 251, 0.5)",
            data: totally_vaccinated,
          }]
      },
      options: {
        legend: {
          display: true,
          position: 'bottom',
          labels: {
            usePointStyle: false,
            fontSize: 10,
            boxWidth: 10,
            padding: 15,
          }
        },
        tooltips: {
          mode: 'index',
          intersect: false,
          callbacks: {
            label: function (tooltipItem, data) {
              var label = data.datasets[tooltipItem.datasetIndex].label || '';

              if (label) {
                label += ': ';
              }
              const dataNum = Math.round(tooltipItem.yLabel * 100) / 100;
              label += format.transform(dataNum);
              return label;
            }
          }
        },
        scales: {
          xAxes: [{
            barPercentage: 0.25,
            beginAtZero: true,
            ticks: {
              autoSkip: false,
              fontSize: 10,
            },
            stacked: true,
            gridLines: {
              display: false,
              drawBorder: false,
            },
          }],
          yAxes: [{
            stacked: true,
            barPercentage: 0.35,
            gridLines: {
              color: 'rgb(247, 250, 252)',
              borderDash: [5, 0],
              zeroLineColor: 'rgb(247, 250, 252)',
            },
            ticks: {
              fontSize: 9,
              beginAtZero: true,
              callback: function (label, index, labels) {
                return label / 1000 + 'k';
              }
            }
          }]
        },
      }
    };

    var ctx = $('#vaccination-coverage-by-state');
    this.vaccinationCoverageByStateChart = new Chart(ctx, configuration);
    this.vaccinationCoverageByStateChart.update();

  }

  //vaccination By Age
  loadVaccinationByAgeChart() {
    const format = this.numberFormatPipe;
    if (this.vaccinationByAgeChart) {
      this.vaccinationByAgeChart.destroy();
    }
    const labels_data = Object.keys(this.vaccinationByAgeChartData);
    const labels = labels_data.map(obj => obj.replace('vac_', '').replace('_', '-'));
    labels.shift();
    const data = Object.values(this.vaccinationByAgeChartData);
    data.shift();
    var configuration = {
      type: 'bar',
      data: {
        labels: labels,
        datasets: [{
          type: 'bar',
          label: 'Vaccinations By Age',
          backgroundColor: "rgb(245, 67, 148)",
          borderColor: "rgb(245, 67, 148)",
          data: data,
        }]
      },
      options: {
        legend: {
          display: true,
          position: 'bottom',
          labels: {
            usePointStyle: false,
            fontSize: 10,
            boxWidth: 10,
            padding: 15,
          }
        },
        tooltips: {
          mode: 'index',
          intersect: false,
          callbacks: {
            label: function (tooltipItem, data) {
              var label = data.datasets[tooltipItem.datasetIndex].label || '';

              if (label) {
                label += ': ';
              }
              const dataNum = Math.round(tooltipItem.yLabel * 100) / 100;
              label += format.transform(dataNum);
              return label;
            }
          }
        },
        scales: {
          xAxes: [{
            barPercentage: 0.25,
            beginAtZero: true,
            ticks: {
              autoSkip: false,
              fontSize: 10,
            },
            stacked: true,
            gridLines: {
              display: false,
              drawBorder: false,
            },
          }],
          yAxes: [{
            stacked: true,
            barPercentage: 0.35,
            gridLines: {
              color: 'rgb(247, 250, 252)',
              borderDash: [5, 0],
              zeroLineColor: 'rgb(247, 250, 252)',
            },
            ticks: {
              fontSize: 9,
              beginAtZero: true,
              callback: function (label, index, labels) {
                return label / 1000 + 'k';
              }
            }
          }]
        },
      }
    };

    var ctx = $('#vaccination-by-age');
    this.vaccinationByAgeChart = new Chart(ctx, configuration);
    this.vaccinationByAgeChart.update();
  }

  //vaccination trend last 7 days (stacked by dose)
  loadVaccinationDoseLastSevenDaysChart() {
    const format = this.numberFormatPipe;
    if (this.vaccinationDoseChart) {
      this.vaccinationDoseChart.destroy();
    }
    const labels = this.vaccinationDoseChartData.map(obj => moment(obj.vaccine_date).format('DD MMM'));
    const doseOne = this.vaccinationDoseChartData.map(obj => obj.dose_one);
    const doseTwo = this.vaccinationDoseChartData.map(obj => obj.dose_two);

    var configuration = {
      type: 'bar',
      data: {
        labels: labels,
        datasets: [{
          type: 'bar',
          label: 'Dose 1',
          backgroundColor: "rgb(85 86 253)",
          borderColor: "rgb(85 86 253)",
          data: doseOne,
        }, {
          type: 'bar',
          label: 'Dose 2',
          backgroundColor: "rgb(75 222 219)",
          borderColor: "rgb(75 222 219)",
          data: doseTwo,
        }]
      },
      options: {
        legend: {
          display: true,
          position: 'bottom',
          labels: {
            usePointStyle: false,
            fontSize: 10,
            boxWidth: 10,
            padding: 15,
          }
        },
        tooltips: {
          mode: 'index',
          intersect: false,
          callbacks: {
            label: function (tooltipItem, data) {
              var label = data.datasets[tooltipItem.datasetIndex].label || '';

              if (label) {
                label += ': ';
              }
              const dataNum = Math.round(tooltipItem.yLabel * 100) / 100;
              label += format.transform(dataNum);
              return label;
            }
          }
        },
        scales: {
          xAxes: [{
            barPercentage: 0.25,
            beginAtZero: true,
            ticks: {
              autoSkip: false,
              fontSize: 10,
            },
            stacked: true,
            gridLines: {
              display: false,
              drawBorder: false,
            },
          }],
          yAxes: [{
            stacked: true,
            barPercentage: 0.35,
            gridLines: {
              color: 'rgb(247, 250, 252)',
              borderDash: [5, 0],
              zeroLineColor: 'rgb(247, 250, 252)',
            },
            ticks: {
              fontSize: 9,
              beginAtZero: true,
              callback: function (label, index, labels) {
                return label / 1000 + 'k';
              }
            }
          }]
        },
      }
    };

    var ctx = $('#vaccination-trends-seven-days');
    this.vaccinationDoseChart = new Chart(ctx, configuration);
    this.vaccinationDoseChart.update();
  }

  //load AEFI report
  loadVaccinationAEFIChart() {
    const format = this.numberFormatPipe;

    if (this.vaccinationAEFIChart) {
      this.vaccinationAEFIChart.destroy();
    }
    const labels = this.vaccinationAEFIChartData.map(obj => moment(obj.vaccine_date).format('DD MMM'));
    const data = _.map(this.vaccinationAEFIChartData, 'aefi');
    var configuration = {
      type: 'bar',
      data: {
        labels: labels,
        datasets: [{
          type: 'bar',
          label: 'AEFI',
          backgroundColor: "rgb(85 86 253)",
          borderColor: "rgb(85 86 253)",
          data: data,
        }]
      },
      options: {
        legend: {
          display: true,
          position: 'bottom',
          labels: {
            usePointStyle: false,
            fontSize: 10,
            boxWidth: 10,
            padding: 15,
          }
        },
        tooltips: {
          mode: 'index',
          intersect: false,
          callbacks: {
            label: function (tooltipItem, data) {
              var label = data.datasets[tooltipItem.datasetIndex].label || '';

              if (label) {
                label += ': ';
              }
              const dataNum = Math.round(tooltipItem.yLabel * 100) / 100;
              label += format.transform(dataNum);
              return label;
            }
          }
        },
        scales: {
          xAxes: [{
            barPercentage: 0.25,
            beginAtZero: true,
            ticks: {
              autoSkip: false,
              fontSize: 10,
            },
            stacked: true,
            gridLines: {
              display: false,
              drawBorder: false,
            },
          }],
          yAxes: [{
            stacked: true,
            barPercentage: 0.35,
            gridLines: {
              color: 'rgb(247, 250, 252)',
              borderDash: [5, 0],
              zeroLineColor: 'rgb(247, 250, 252)',
            },
            ticks: {
              fontSize: 9,
              beginAtZero: true,
              // callback: function (label, index, labels) {
              //   return label / 1000 + 'k';
              // }
            }
          }]
        },
      }
    };

    var ctx = $('#vaccination-aefi-seven-days');
    this.vaccinationAEFIChart = new Chart(ctx, configuration);
    this.vaccinationAEFIChart.update();

  }

  //vaccination brand last 7 days chart
  loadVaccinationBrandLastSevenDaysChart() {
    const format = this.numberFormatPipe;
    if (this.vaccinationBrandChart) {
      this.vaccinationBrandChart.destroy();
    }
    const labels = this.vaccinationBrandChartData.map(obj => moment(obj.vaccine_date).format('DD MMM'));
    const doseOne = this.vaccinationBrandChartData.map(obj => obj.covishield);
    const doseTwo = this.vaccinationBrandChartData.map(obj => obj.covaxin);

    var configuration = {
      type: 'bar',
      data: {
        labels: labels,
        datasets: [{
          type: 'bar',
          label: 'Covishield',
          backgroundColor: "rgb(85 86 253)",
          borderColor: "rgb(85 86 253)",
          data: doseOne,
        }, {
          type: 'bar',
          label: 'Covaxin',
          backgroundColor: "rgb(75 222 219)",
          borderColor: "rgb(75 222 219)",
          data: doseTwo,
        }]
      },
      options: {
        legend: {
          display: true,
          position: 'bottom',
          labels: {
            usePointStyle: false,
            fontSize: 10,
            boxWidth: 10,
            padding: 15,
          }
        },
        tooltips: {
          mode: 'index',
          intersect: false,
          callbacks: {
            label: function (tooltipItem, data) {
              var label = data.datasets[tooltipItem.datasetIndex].label || '';

              if (label) {
                label += ': ';
              }
              const dataNum = Math.round(tooltipItem.yLabel * 100) / 100;
              label += format.transform(dataNum);
              return label;
            }
          }
        },
        scales: {
          xAxes: [{
            barPercentage: 0.25,
            beginAtZero: true,
            ticks: {
              autoSkip: false,
              fontSize: 10,
            },
            stacked: true,
            gridLines: {
              display: false,
              drawBorder: false,
            },
          }],
          yAxes: [{
            stacked: true,
            barPercentage: 0.35,
            gridLines: {
              color: 'rgb(247, 250, 252)',
              borderDash: [5, 0],
              zeroLineColor: 'rgb(247, 250, 252)',
            },
            ticks: {
              fontSize: 9,
              beginAtZero: true,
              callback: function (label, index, labels) {
                return label / 1000 + 'k';
              }
            }
          }]
        },
      }
    };

    var ctx = $('#vaccination-brand-seven-days');
    this.vaccinationBrandChart = new Chart(ctx, configuration);
    this.vaccinationBrandChart.update();
  }
}
